<template>
    <div>
        <input :value="data"
               ref="input"
               placeholder="请从素材库上传并复制链接至此"/>
    </div>
</template>

<script>
	export default {
		name: "ImagePicker",
		props: {
			data: {
				required: true
			}
		},
		methods: {
			getValue() {
				return this.$refs.input.value;
			}
		}
	}
</script>

<style scoped>
    input {
        width: 100%;
        max-width: 600px;
        box-sizing: border-box;
    }
</style>